export default "__VITE_ASSET__95ab6d96__"